export default "/fonts/PublicSans-Regular.ttf?4923208255b32cd2980c98985ddc7fea";